import React, { Component } from 'react'
import { Grid, Row, Col, Glyphicon, Table, DropdownButton, MenuItem } from 'react-bootstrap'
import { connect } from 'react-redux'
import { CSVLink } from 'react-csv/lib'
import moment from 'moment'
import { byField, stringMatchInsensitive } from '../../../common/utils'

import DeliveryRow from './DeliveryRow'
import { fetchCollection } from '../../../common/redux/collectionActions'

const translateQsignReason = {
  too_big: 'För stort gods',
  no_event: 'Ej levererad till enhet',
}

class DeliveriesContainer extends Component {
  state = {
    search: '',
    page: 0,
    csvData: [[]],
    selectedLocks: [],
    selectedVendors: [],
    selectedQsignReasons: [],
    selectedCities: [],
  }

  search = (e) => {
    this.setState({ search: e.target.value })
  }

  exportCSV = (deliveries) => {
    if (!deliveries || !deliveries.length) return
    const csvData = [['Avsändare', 'Mottagaradress', 'PaketID', 'LeveransID', 'Chaufför', 'Skapad', 'Levererad år', 'Levererad månad', 'Levererad dag', 'Levererad tid', 'Levererad till Qlocx-container', 'Avvikelsestatus']]

    for (const d of deliveries) {
      const checkoutDate = d.checkout && d.checkout.date

      csvData.push([
        `${d.vendor && d.vendor.name ? d.vendor.name : 'Saknas'}`,
        `${d.lock.address ? d.lock.address.street : 'Saknas'}`,
        `${d.packageid || ''}-`,
        `${d.deliveryId || d.carrierInternalOrderId || ''}-`,
        `${d.driverName || '-'} ${d.driverAliases || ''}`,
        `${moment(new Date(parseInt(d._id.substring(0, 8), 16) * 1000)).format('YYYY/MM/DD - HH:mm')}`,
        `${checkoutDate ? moment(checkoutDate).format('YYYY') : ''}`,
        `${checkoutDate ? moment(checkoutDate).format('MM') : ''}`,
        `${checkoutDate ? moment(checkoutDate).format('DD') : ''}`,
        `${checkoutDate ? moment(checkoutDate).format('HH:mm') : ''}`,
        `${checkoutDate ? (d.qsign === false ? 'Nej' : 'Ja') : ''}`,
        `${d.qsignReason ? translateQsignReason[d.qsignReason.toLowerCase()] : ''}`,
      ])
    }

    this.setState({ csvData }, () => this.csvLink.link.click())
  }

  onFetchMoreDeliveries = () => {
    const page = this.state.page + 1

    this.props.fetchCollection('deliveries', { page })
    this.setState({ page })
  }

  toggleSelect = (arrName, val) => {
    const newState = { ...this.state }
    if (this.state[arrName].includes(val)) {
      newState[arrName] = newState[arrName].filter((f) => f !== val)
    } else {
      newState[arrName].push(val)
    }

    this.setState(newState)
  }

  render() {
    const { deliveries } = this.props
    const { csvData } = this.state
    if (!deliveries) return null

    const { selectedLocks, selectedCities, selectedVendors, selectedQsignReasons, search } = this.state

    const searchedDeliveries = deliveries
      .filter((del) => {
        const { vendor, lock, qsignReason } = del
        if (!selectedLocks.length && !selectedVendors.length && !selectedCities.length && !selectedQsignReasons.length) return true

        if (!selectedLocks.length || selectedLocks.includes(lock.custom_name)) return true

        return false
      })
      .filter((del) => !selectedVendors.length || selectedVendors.includes(del.vendor.name))
      .filter((del) => !selectedQsignReasons.length || selectedQsignReasons.includes(del.qsignReason))
      .filter((del) => !selectedCities.length || selectedCities.includes(del.lock.address?.city))
      .filter((del) => {
        const { vendor, lock, packageid, driverName } = del
        if (search.length) {
          if (stringMatchInsensitive(vendor.name, search)) return true
          if (stringMatchInsensitive(lock.custom_name, search)) return true
          if (stringMatchInsensitive(`${lock.address.street} ${lock.address.city} ${lock.address.zip}`, search)) return true
          if (stringMatchInsensitive(packageid, search)) return true
          if (stringMatchInsensitive(driverName, search)) return true
        } else {
          return true
        }

        return false
      })

    const finishedDeliveries = searchedDeliveries.filter((del) => del.checkout && del.checkout.date)
    const unfinishedDeliveries = searchedDeliveries.filter((del) => !del.checkout || !del.checkout.date)

    const { lockNames, vendorNames, qsignReasons } = this.props.names
    const uniqueCities = [...new Set(deliveries.map((delivery) => delivery.lock?.address?.city))].filter((city) => city !== undefined)

    return (
      <Grid>
        <br />
        <br />
        <Row>
          <Col xs={12} md={3} lg={1} style={{ textAlign: 'center' }}>
            <DropdownButton className="delivery-filter-container" title={selectedLocks.length > 0 ? `Valda: ${selectedLocks.length} ` : 'Projekt '} id="bg-nested-dropdown">
              <MenuItem style={{ backgroundColor: 'rgb(230, 230, 230)' }} className="dropdown-menu-item" onSelect={() => this.setState({ selectedLocks: [] })}>
                <div>Återställ filter </div>
              </MenuItem>
              <div style={{ maxHeight: '410px', overflowY: 'scroll' }}>
                {lockNames.sort(byField()).map((lockName, i) => (
                  <MenuItem key={i} onSelect={() => this.toggleSelect('selectedLocks', lockName)} className="dropdown-menu-item" eventKey={i}>
                    <Glyphicon glyph={`glyphicon glyphicon-${selectedLocks.includes(lockName) ? 'check' : 'unchecked'}`} style={{ color: 'grey', marginRight: '5px', marginLeft: '5px', float: 'left' }} />
                    <div style={{ marginLeft: '5px', textAlign: 'left', color: 'black' }}>{lockName}</div>
                  </MenuItem>
                ))}
              </div>
            </DropdownButton>
          </Col>
          <Col xs={12} md={3} lg={2} style={{ textAlign: 'center' }}>
            <DropdownButton className="delivery-filter-container" title={selectedCities.length > 0 ? `Valda: ${selectedCities.length} ` : 'Ort'} id="bg-nested-dropdown">
              <MenuItem style={{ backgroundColor: 'rgb(230, 230, 230)' }} className="dropdown-menu-item" onSelect={() => this.setState({ selectedCities: [] })}>
                <div>Återställ filter </div>
              </MenuItem>
              <div style={{ maxHeight: '410px', overflowY: 'scroll' }}>
                {uniqueCities.map((city, i) => (
                  <MenuItem key={i} onSelect={() => this.toggleSelect('selectedCities', city)} className="dropdown-menu-item" eventKey={i}>
                    <Glyphicon glyph={`glyphicon glyphicon-${selectedCities.includes(city) ? 'check' : 'unchecked'}`} style={{ color: 'grey', marginRight: '5px', marginLeft: '5px', float: 'left' }} />
                    <div style={{ marginLeft: '5px', textAlign: 'left', color: 'black' }}>{city}</div>
                  </MenuItem>
                ))}
              </div>
            </DropdownButton>
          </Col>

          <Col style={{ backgroundColor: 'white', borderBottom: '3px solid #006e78' }} md={12} lg={3} sm={12}>
            <Glyphicon glyph="search" style={{ fontSize: '20px', color: '#5b5b5b', lineHeight: '2' }} />
            <input style={{ width: '90%', border: 'none', padding: '5px' }} value={this.state.search} onChange={this.search} type="text" placeholder="Sök på paket-id eller avsändare" />
          </Col>

          <Col xs={12} md={3} lg={2} style={{ textAlign: 'center' }}>
            <DropdownButton className="delivery-filter-container" title={selectedVendors.length > 0 ? `Valda: ${selectedVendors.length} ` : 'Avsändare '} id="bg-nested-dropdown">
              <MenuItem style={{ backgroundColor: 'rgb(230, 230, 230)' }} className="dropdown-menu-item" onSelect={() => this.setState({ selectedVendors: [] })}>
                <div>Återställ filter </div>
              </MenuItem>
              <div style={{ maxHeight: '410px', overflowY: 'scroll' }}>
                {vendorNames.sort(byField()).map((vendorName, i) => (
                  <MenuItem key={i} onSelect={() => this.toggleSelect('selectedVendors', vendorName)} className="dropdown-menu-item" eventKey={i}>
                    <Glyphicon glyph={`glyphicon glyphicon-${selectedVendors.includes(vendorName) ? 'check' : 'unchecked'}`} style={{ color: 'grey', marginRight: '5px', marginLeft: '5px', float: 'left' }} />
                    <div style={{ marginLeft: '5px', textAlign: 'left', color: 'black' }}>{vendorName}</div>
                  </MenuItem>
                ))}
              </div>
            </DropdownButton>
          </Col>

          <Col xs={12} md={3} lg={1} style={{ textAlign: 'center' }}>
            <DropdownButton className="delivery-filter-container" title={selectedQsignReasons.length > 0 ? `Valda: ${selectedQsignReasons.length} ` : 'Status '} id="bg-nested-dropdown">
              <MenuItem style={{ backgroundColor: 'rgb(230, 230, 230)' }} className="dropdown-menu-item" onSelect={() => this.setState({ selectedQsignReasons: [] })}>
                <div>Återställ filter </div>
              </MenuItem>
              <div style={{ maxHeight: '410px', overflowY: 'scroll' }}>
                {qsignReasons.sort(byField()).map((qsignReason, i) => (
                  <MenuItem key={i} onSelect={() => this.toggleSelect('selectedQsignReasons', qsignReason)} className="dropdown-menu-item" eventKey={i}>
                    <Glyphicon glyph={`glyphicon glyphicon-${selectedQsignReasons.includes(qsignReason) ? 'check' : 'unchecked'}`} style={{ color: 'grey', marginRight: '5px', marginLeft: '5px', float: 'left' }} />
                    <div style={{ marginLeft: '5px', textAlign: 'left', color: 'black' }}>{translateQsignReason[qsignReason]}</div>
                  </MenuItem>
                ))}
              </div>
            </DropdownButton>
          </Col>
          <Col xs={12} md={3} lg={2} style={{ textAlign: 'center' }}>
            <div className="pull-right">
              <button onClick={() => this.exportCSV(searchedDeliveries)} className="smallQbutton" style={{ borderRadius: 10 }}>
                Exportera
              </button>
              <CSVLink
                data={csvData}
                filename="AllLeveransExport.csv"
                className="hidden"
                separator={';'}
                ref={(r) => {
                  this.csvLink = r
                }}
                target="_blank"
              />
            </div>
          </Col>
        </Row>
        <br />
        <br />
        <br />
        <Row>
          <Col md={12} lg={12} sm={12}>
            <Table responsive style={{ backgroundColor: 'white' }}>
              <thead>
                <tr>
                  <th>Avsändare</th>
                  <th>Mottagaradress</th>
                  <th>Paket-id</th>
                  <th>Lev.-id</th>
                  <th>Skapad</th>
                  <th>Levererad</th>
                  <th>Godkänd</th>
                  <th>Chaufför</th>
                  <th>Sätt status</th>
                  {/* <th>Område</th>
                                <th>Chaufförs-id</th>
                                <th></th>
                                <th>Senast aktiv</th> */}
                </tr>
              </thead>
              <tbody>
                <tr style={{ backgroundColor: '#edeef1' }}>
                  <td>
                    <h4 style={{ fontWeight: 700 }}>Leveranser på väg ({unfinishedDeliveries.length})</h4>
                  </td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                {unfinishedDeliveries.map((delivery, i) => (
                  <DeliveryRow key={i} delivery={delivery} />
                ))}
                <tr style={{ backgroundColor: '#edeef1' }}>
                  <td>
                    <h4 style={{ fontWeight: 700 }}>Avslutade leveranser ({finishedDeliveries.length})</h4>
                  </td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                {finishedDeliveries.map((delivery, i) => (
                  <DeliveryRow key={i} delivery={delivery} />
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
        <div style={{ paddingTop: 30 }} className="flex">
          <button className="smallQbutton" onClick={this.onFetchMoreDeliveries}>
            Hämta 30 leveranser till
          </button>
        </div>
      </Grid>
    )
  }
}

const mapProps = (state) => {
  const names = state.collectionData.deliveries.reduce(
    (acc, val) => {
      if (!acc.lockNames.includes(val.lock.custom_name)) acc.lockNames.push(val.lock.custom_name)
      if (!acc.vendorNames.includes(val.vendor.name)) acc.vendorNames.push(val.vendor.name)
      if (val.qsignReason && val.qsignReason.length && !acc.qsignReasons.includes(val.qsignReason)) acc.qsignReasons.push(val.qsignReason)

      return acc
    },
    { lockNames: [], vendorNames: [], qsignReasons: [] }
  )

  return {
    deliveries: state.collectionData.deliveries,
    names,
  }
}

const mapDispatch = (dispatch) => ({
  fetchCollection: (col, params) => dispatch(fetchCollection(col, params)),
})

export default connect(mapProps, mapDispatch)(DeliveriesContainer)
